/**
 * Map marker icons — shared by the live Cesium map, flight replay, and
 * sensor layer so every surface renders the same drone/pilot/sensor/home
 * sprite. SVGs are imported as raw text (Vite `?raw`) and converted to
 * base64 data URIs so they can be handed straight to `BillboardGraphics.image`
 * without an extra async fetch at render time.
 */
import droneSvg from './icons/drone.svg?raw';
import pilotSvg from './icons/pilot.svg?raw';
import sensorSvg from './icons/sensor.svg?raw';
import homePointSvg from './icons/home-point.svg?raw';

function toDataUri(svg: string): string {
  const encoded = typeof btoa === 'function' ? btoa(svg) : '';
  return `data:image/svg+xml;base64,${encoded}`;
}

export const DRONE_ICON_DATA_URI = toDataUri(droneSvg);
export const PILOT_ICON_DATA_URI = toDataUri(pilotSvg);
export const SENSOR_ICON_DATA_URI = toDataUri(sensorSvg);
export const HOME_POINT_ICON_DATA_URI = toDataUri(homePointSvg);
